import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography
} from '@mui/material';

export default function SendUserSms({ open, hideModal, onSend }) {
  const [smsText, setSmsText] = useState('');

  const handleSend = () => {
    onSend(smsText);
    setSmsText('');
    hideModal();
  };

  return (
    <Dialog open={open} onClose={hideModal} >
      <DialogContent >
        <Typography style = {{fontWeight: "bold", fontSize: "18px", marginBottom: "10px"}}>
          Please enter the SMS text to send to the user:
        </Typography>
        <TextField
          label="SMS Text"
          multiline
          rows={4}
          value={smsText}
          style = {{marginTop: "10px", fontSize: "16px"}}
          onChange={(e) => setSmsText(e.target.value)}
          variant="outlined"
          fullWidth
        />
      </DialogContent>
      <DialogActions style = {{marginRight: "16px", marginBottom: "10px"}}>
        <Button onClick={hideModal} style = {{color: "#19274B"}}>
          Cancel
        </Button>
        <Button onClick={handleSend} variant="contained" style = {{
             backgroundColor: "#19274B"
        }}>
          Send SMS
        </Button>
      </DialogActions>
    </Dialog>
  );
}
